import { render, staticRenderFns } from "./HeadLine.vue?vue&type=template&id=637d6679&scoped=true&"
import script from "./HeadLine.vue?vue&type=script&lang=js&"
export * from "./HeadLine.vue?vue&type=script&lang=js&"
import style0 from "./HeadLine.vue?vue&type=style&index=0&id=637d6679&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637d6679",
  null
  
)

export default component.exports